import { StorageModule } from "../modules/storage";
import { deepCopy, duplicateRemoval } from '../util';
import { message } from "antd";
import * as apis from '../api/networkDisk'
import { tictactoeState, setTictactoe } from './common'

interface Action {
    type: string;
    data: any;
    path?: string;
}

interface State {
    memoNode: any
    labelPop: any
    taskVisible: any
    wordVisible:any
    markDownVisible: any
    memoModal: any
    memoHtmlVisible:any
    imgPreview: any
    selectTagVisible: any
    memoOperation: any

}
const memoVisibleState = {
    memoNode: {},
    labelPop: false,
    taskVisible: false,
    wordVisible:false,
    markDownVisible: false,
    memoModal: false,
    memoHtmlVisible:false,
    imgPreview: false,
    selectTagVisible: false,
    memoOperation: {
        operationType: 'memos',
        isAdd: false
    }
}

const setMemoVisibleState = (state: State, action: Action) => {
    switch (action.type) {
        case 'SET_CNODE': {
            console.log('SET_CNODE', action.data)
            state.memoNode = action.data
            return { ...state }
        }
        case 'SET_SELECTTAGVISIBLE': {
            console.log('SET_SELECTTAGVISIBLE', action.data)
            state.selectTagVisible = action.data
            if (!action.data) {
                setMemoVisibleState(state, { type: 'SET_CLOSEALL_LABELPOP', data: false })
            }
            return { ...state }
        }
        case 'SET_CLOSEALL_LABELPOP': {
            setMemoVisibleState(state, { type: 'SET_MARKDOWNVISIBLE', data: false })
            setMemoVisibleState(state, {
                type: 'SET_MEMOMODAL', data: {
                    visible: false,
                    operationType: state.memoOperation.operationType,
                    isAdd: state.memoOperation.isAdd
                }
            })
            setMemoVisibleState(state, { type: 'SET_TASKVISIBLE', data: false })
            setMemoVisibleState(state, { type: 'SET_MEMOHTMLVISIBLE', data: false })
            setMemoVisibleState(state, { type: 'SET_WORDVISIBLE', data: false })

            return { ...state }
        }
        // 识别弹出标签类型
        case 'SET_LABELPOP': {
            console.log('SET_LABELPOP', action.data)
            console.log('memoVisibleState', state.memoNode)
            console.log('tictactoeState', tictactoeState.subjectInfo)
            setMemoVisibleState(state, { type: 'SET_SELECTTAGVISIBLE', data: true })
            if (action.data) {
                const mimeType = state.memoNode?.mimeType || null
                let _taskList = tictactoeState.tagMeta.filter((i: any) => i.mimeType === mimeType)
                console.log(_taskList)
                if (mimeType === 'text/markdown') {
                    setMemoVisibleState(state, { type: 'SET_MARKDOWNVISIBLE', data: action.data })
                } else if (mimeType === 'image/*') {
                    console.log('11')
                    taskTab(state, { ..._taskList[0] })
                    // setTaskVisible(true)
                } else if (mimeType === 'image/m2ni-img-notas') {
                    taskTab(state, { ..._taskList[0] })
                }else if (mimeType === 'text/webpage'){
                    setMemoVisibleState(state, { type: 'SET_MEMOHTMLVISIBLE', data: action.data })
                }else if(mimeType=='application/msword' || mimeType=='application/vnd.ms-excel' || mimeType=='application/vnd.ms-powerpoint'){
                    setMemoVisibleState(state, { type: 'SET_WORDVISIBLE', data: action.data })
                } else {
                    console.log('编辑走这个')
                    setMemoVisibleState(state, {
                        type: 'SET_MEMOMODAL', data:
                        {
                            visible: action.data,
                            operationType: state.memoOperation.operationType,
                            isAdd: state.memoOperation.isAdd
                        }
                    })
                }
            } else {
                // setMemoVisibleState(state, { type: 'SET_TASKVISIBLE', data: false })
            }
            state.labelPop = action.data
            return { ...state }
        }
        //任务弹窗
        case 'SET_TASKVISIBLE': {
            console.log('SET_TASKVISIBLE', action.data)
            state.taskVisible = action.data
            if (action.data) {
                setMemoVisibleState(state, { type: 'SET_SELECTTAGVISIBLE', data: true })
            }
            return { ...state }
        }
        //文稿弹窗
        case 'SET_WORDVISIBLE': {
            console.log('SET_WORDVISIBLE', action.data)
            state.wordVisible = action.data
            if (action.data) {
                setMemoVisibleState(state, { type: 'SET_SELECTTAGVISIBLE', data: true })
            }
            return { ...state }
        }
        //markDown弹窗
        case 'SET_MARKDOWNVISIBLE': {
            state.markDownVisible = action.data
            return { ...state }
        }
        //网页格式
        case 'SET_MEMOHTMLVISIBLE': {
            state.memoHtmlVisible = action.data
            return { ...state }
        }
        case 'SET_MEMOMODAL': {
            console.log('SET_MEMOMODAL', action.data)
            state.memoModal = action.data.visible
            state.memoOperation = {
                operationType: action.data.operationType,
                isAdd: action.data.isAdd
            }
            if (action.data.visible) {
                setMemoVisibleState(state, { type: 'SET_SELECTTAGVISIBLE', data: true })
            }
            return { ...state }
        }
        case 'SET_TASKTABFUN': {
            taskTab(state, action.data)
            return { ...state }
        }
        case 'SET_IMGPREVIEW': {
            state.imgPreview = action.data
            return { ...state }
        }

        default: {
            return state
        }
    }
}
const taskTab = (state: any, i: any) => {
    console.log('taskTab', i)
    let info: any = {}
    if (i.name === '任务计划') {
        info = { ...i, label1: '计划完成时间', label2: '预计工时' }
    } else if (i.name === '开始执行') {
        info = { ...i, label1: '预计完成时间', label2: '预计工时' }
    }
    else if (i.name === '任务完成') {
        info = { ...i, label1: '实际完成时间', label2: '实际工时' }
    }
    else if (i.name === '版本计划') {
        info = { ...i, label1: '版本号', }
    }
    else {
        info = { ...i, }
    }
    setMemoVisibleState(state, { type: 'SET_TASKVISIBLE', data: true })
    setTictactoe(state, { type: 'SET_SELECTTAGMETA', data: info })
}
export {
    memoVisibleState,
    setMemoVisibleState
}

